import { render, staticRenderFns } from "./disabledUser.vue?vue&type=template&id=2e9674f8&"
import script from "./disabledUser.vue?vue&type=script&lang=js&"
export * from "./disabledUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports